<template>
    <div class="modal fade custom-modal-width" :id="'list_goods_modal_'+cargo_id" tabindex="-1" role="dialog" :aria-labelledby="'list_goods_modal_'+cargo_id+'_label'" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="'list_goods_modal_'+cargo_id">{{ goods_trans }}</h5>
                    <button type="button" class="close goods-modal-close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="col-md-12 col-sm-12 ">
                        <div class="x_panel">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item" v-if="!departure">
                                    <a class="nav-link active"
                                        @click="show_goods = false"
                                        :id="'available-goods-tab-'+cargo_id"
                                        data-toggle="tab"
                                        :href="'#available-goods-'+cargo_id"
                                        role="tab"
                                        aria-controls="available-goods"
                                        aria-selected="true">
                                        {{ goods_trans }}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link"
                                        @click="show_goods = true"
                                        :class="{ 'active': departure }"
                                        :id="'assigned-goods-tab-'+cargo_id"
                                        data-toggle="tab"
                                        :href="'#assigned-goods-'+cargo_id"
                                        role="tab"
                                        aria-controls="assigned-goods"
                                        aria-selected="false">
                                        {{ assigned_goods_trans }} (<span :id="'assigned_goods_count_'+cargo_id">{{ assigned_goods_count }}</span>)
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane fade show active" :id="'available-goods-'+cargo_id" role="tabpanel" aria-labelledby="available-goods-tab" v-if="!departure">
                                    <div class="mt-1" v-if="!is_cargo_from_goods">
                                        <datatables-component
                                            :table_id="'list_goods_table_'+cargo_id"
                                            :headers_json="goods_header"
                                            sort_key="id"
                                            sort_dir="asc"
                                            :data_url="goods_table_route"
                                            :filter_header="true"
                                            :non_sorting="['actions']"
                                        />
                                    </div>
                                    <div class="mt-1" v-if="is_cargo_from_goods">
                                        <datatables-component
                                            :table_id="'terminal_goods_warehouse_table_'+cargo_id"
                                            :headers_json="cargo_goods_header"
                                            sort_key="terminal_goods.created_at"
                                            sort_dir="desc"
                                            :filter_header="true"
                                            :data_url="goods_warehouse_route"
                                            :non_sorting="['document_icons_html', 'num']"
                                            :create_cargo_btn_trans="create_cargo_btn_trans"
                                            :show_negative_quantity_goods_trans="show_negative_quantity_goods_trans"
                                        />
                                    </div>
                                </div>
                                <div class="tab-pane fade" :class="{ 'show active': departure }" :id="'assigned-goods-'+cargo_id" role="tabpanel" aria-labelledby="assigned-goods-tab" >
                                    <div class="mt-1" v-if="show_goods">
                                        <datatables-component
                                            :table_id="'list_cargo_goods_table_'+cargo_id"
                                            :headers_json="cargo_goods_pivot_header"
                                            sort_key="id"
                                            sort_dir="asc"
                                            :data_url="cargo_goods_route"
                                            :filter_header="false"
                                            :non_sorting="['actions']"
                                        />
                                    </div>
                                    <div class="col-md-12 col-sm-12" v-if="is_cargo_unconfirmed && !is_cargo_from_goods">
                                        <button type="button" class="btn btn-success btn-sm action-btn" onclick="updateCargoGoodsQuantities(this)">
                                            {{ update_quantities_trans }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'is_cargo_from_goods': {
            'type': Boolean,
            'required': false,
            'default': false,
        },
        'departure': {
            'type': Boolean,
            'required': false,
            'default': false,
        },
        'is_cargo_unconfirmed': {
            'type': Boolean,
            'required': true,
        },
        'cargo_goods_route': {
            'type': String,
            'required': true,
        },
        'cargo_goods_pivot_header': {
            'type': String,
            'required': false,
        },
        'cargo_goods_header': {
            'type': String,
            'required': false,
        },
        'goods_table_route': {
            'type': String,
            'required': true,
        },
        'goods_warehouse_route': {
            'type': String,
            'required': false,
        },
        'goods_header': {
            'type': String,
            'required': true,
        },
        'assigned_goods_trans': {
            'type': String,
            'required': true,
        },
        'create_cargo_btn_trans': {
            'type': String,
            'required': false,
        },
        'assign_checked_trans': {
            'type': String,
            'required': true,
        },
        'update_quantities_trans': {
            'type': String,
            'required': true,
        },
        'goods_trans': {
            'type': String,
            'required': true,
        },
        'cargo_id': {
            'type': Number,
            'required': true,
        },
        'assigned_goods_count': {
            'type': Number,
            'required': false,
        },
        'show_goods': {
            'type': Boolean,
            'required': false,
            'default': true,
        },
        'show_negative_quantity_goods_trans': {
            'type': String,
            'required': false,
        },
    },
}
</script>
